import { render, staticRenderFns } from "./PreQuestion1.vue?vue&type=template&id=1a4b2a8f&scoped=true&"
import script from "./PreQuestion1.vue?vue&type=script&lang=js&"
export * from "./PreQuestion1.vue?vue&type=script&lang=js&"
import style0 from "./PreQuestion1.vue?vue&type=style&index=0&id=1a4b2a8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b2a8f",
  null
  
)

export default component.exports